export enum TableName {
  Jobs = 'job',
  Cars = 'vehicles',
  Shuttles = 'shuttles',
  Trips = 'trips',
  Drivers = 'drivers',
  Passengers = 'passengers',
  Users = 'moderators',
  Invitations = 'invitations',
  DriverShifts = 'driverShifts',
  Shifts = 'shifts',
  Services = 'services',
  Holidays = 'holidays',
  Rates = 'rates',
  Locations = 'locations',
  Suppliers = 'suppliers',
  ExtraServices = 'extraservices',
  Profiles = 'profiles',
  Areas = 'areas',
  Fares = 'fares',
  Sites = 'sites',
  Attributes = 'attributes',
  History = 'history',
  Trans = 'trans',
  DriverReports = 'driverreports',
  ShuttleReports = 'shuttleJobReport',
  VehicleReport = 'vehicle_report',
  Settings = 'settings',
  RateTypes = 'ratetypes',
  UniqueDriversReport = 'reportUniqueDriversPerDay',
  CardBlacklist = 'blacklistCards',
  Automations = 'automations',
  Parents = 'parents',
  CustomRules = 'customRules',
}
